<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_edit" transform="translate(-625 -581)">
      <path
        id="패스_3909"
        data-name="패스 3909"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(625 581)"
      />
      <g id="그룹_8683" data-name="그룹 8683" transform="translate(-2)">
        <rect
          id="사각형_6133"
          data-name="사각형 6133"
          fill="#d5d8dc"
          width="20"
          height="20"
          rx="2"
          transform="translate(629 583)"
        />
        <g
          id="그룹_8682"
          data-name="그룹 8682"
          transform="translate(632.444 586.444)"
        >
          <path
            id="패스_3910"
            data-name="패스 3910"
            fill="#363c43"
            d="M14.894,3a.706.706,0,0,0-.494.2L13.108,4.5l2.646,2.646,1.291-1.291a.7.7,0,0,0,0-.995L15.395,3.2a.693.693,0,0,0-.5-.2Z"
            transform="translate(-4.141 -3)"
          />
          <path
            id="패스_4069"
            data-name="패스 4069"
            fill="#087ef7"
            d="M10.8,5.658,3,13.463v2.646H5.646l7.8-7.8L10.8,5.658Z"
            transform="translate(-3 -2.999)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
